import { useTranslation } from 'react-i18next';
/**
 * Loads translations for this library with proper type checking.
 */
export function useCommonDataTableUiTranslation() {
    return useTranslation('common-data-table-ui');
}
